import { BuildingSystemIcon } from '@/components/icons';
import { cn } from '@/utils/helpers';

type SystemContextLabelProps = {
  label: string;
  className?: string;
  iconSize?: number;
  /** `badge` = purple square behind icon; `plain` = building glyph only (e.g. chat system selector). */
  iconVariant?: 'badge' | 'plain';
};

/** "System: …" row with building icon (chat composer, bulk panel, etc.). */
export function SystemContextLabel({
  label,
  className,
  iconSize = 16,
  iconVariant = 'badge',
}: SystemContextLabelProps) {
  return (
    <span
      className={cn(
        'system-context-label',
        iconVariant === 'plain' && 'system-context-label--plain-icon',
        className
      )}
    >
      <span className="system-context-label__icon" aria-hidden>
        <BuildingSystemIcon size={iconSize} />
      </span>
      <span className="system-context-label__text">System: {label}</span>
    </span>
  );
}
